
import { DistributionStoreNamespace } from "../../modules/distribution/store/index";
import { RoyaltyStoreNamespace } from "../../modules/royalty/store/index";
import {
  ContactSearchTypes,
  contactSearchGetters
} from "../add-contact-relation/models/contact-search-types";


import {
  DistributionAccountInvoiceContact,DistributionAccountDeliveryAddress
} from "../../modules/distribution/store/types"


export const AddContactRelationDict = {
  contact_id_invoice: `${DistributionStoreNamespace}/${DistributionAccountInvoiceContact.SET.ALL}`,
  contact_id_delivery: `${DistributionStoreNamespace}/${DistributionAccountDeliveryAddress.SET.ALL}`,
};

export const getContactRelationAddedAction = key => {
  const action = AddContactRelationDict[key];
  console.log("action",action)
  if (action) {
    return action;
  } else {
    throw Error("No Action Found in Dict");
  }
};

export const ConfigDict = {
  account: {
    contactSearchType: ContactSearchTypes.BOTH,
    templateType: "account",
    ...contactSearchGetters(ContactSearchTypes.BOTH),

  },
  order: {
    contactSearchType: ContactSearchTypes.BOTH,
    templateType: "order",
    ...contactSearchGetters(ContactSearchTypes.BOTH)
  },
  artists: {
    contactSearchType: ContactSearchTypes.BOTH,
    templateType: "artists",
    ...contactSearchGetters(ContactSearchTypes.BOTH)
  },
  calendar_dates: {
    contactSearchType: ContactSearchTypes.INDIVIDUAL,
    templateType: "calendar_dates",
    ...contactSearchGetters(ContactSearchTypes.INDIVIDUAL)
  },
  booking_locations: {
    contactSearchType: ContactSearchTypes.BOTH,
    templateType: "standard",
    ...contactSearchGetters(ContactSearchTypes.BOTH)
  },
  contacts_individual: {
    contactSearchType: ContactSearchTypes.COMPANY,
    templateType: "standard",
    ...contactSearchGetters(ContactSearchTypes.COMPANY)
  },
  contacts: {
    contactSearchType: ContactSearchTypes.INDIVIDUAL,
    templateType: "standard",
    ...contactSearchGetters(ContactSearchTypes.INDIVIDUAL)
  },
  release: {
    contactSearchType: ContactSearchTypes.BOTH,
    templateType: "standard",
    ...contactSearchGetters(ContactSearchTypes.BOTH)
  },
  royalty_account: {
    contactSearchType: ContactSearchTypes.BOTH,
    templateType: "standard",
    ...contactSearchGetters(ContactSearchTypes.BOTH)
  },

  
  label_artist: {
    contactSearchType: ContactSearchTypes.INDIVIDUAL,
    templateType: "standerd",
    ...contactSearchGetters(ContactSearchTypes.INDIVIDUAL)
  },
  label: {
    contactSearchType: ContactSearchTypes.BOTH,
    templateType: "standerd",
    ...contactSearchGetters(ContactSearchTypes.INDIVIDUAL)
  },
  project: {
    contactSearchType: ContactSearchTypes.BOTH,
    templateType: "standerd",
    ...contactSearchGetters(ContactSearchTypes.INDIVIDUAL)
  },

  licence_account:{
    contactSearchType:ContactSearchTypes.BOTH,
    templateType: "standerd",
    ...contactSearchGetters(ContactSearchTypes.COMPANY)

  },

  l_licence_accounts:{
    contactSearchType:ContactSearchTypes.BOTH,
    templateType: "standard",
    ...contactSearchGetters(ContactSearchTypes.BOTH),
   

  },
  l_royalty_accounts:{
    contactSearchType:ContactSearchTypes.BOTH,
    templateType: "standard",
    ...contactSearchGetters(ContactSearchTypes.BOTH),

  },

  l_statements:{
    contactSearchType:ContactSearchTypes.BOTH,
    templateType: "standard",
    ...contactSearchGetters(ContactSearchTypes.BOTH),
   

  },
  supplier:{
    contactSearchType:ContactSearchTypes.BOTH,
    templateType: "standard",
    ...contactSearchGetters(ContactSearchTypes.BOTH),
   

  },
  costs: {
    contactSearchType: ContactSearchTypes.BOTH,
    templateType: "standard",
    ...contactSearchGetters(ContactSearchTypes.BOTH)
  },
  l_orders:{
    contactSearchType:ContactSearchTypes.BOTH,
    templateType: "standard",
    ...contactSearchGetters(ContactSearchTypes.BOTH),
  }
};
export const getContactRelationConfiguration = key => {
  const config = ConfigDict[key];
  if (config) {
    return config;
  } else {
    throw Error("No Config Found in Dict");
  }
};

export const relatedContactSetPayload = () => {
  return {
    contact_relations,
    external_table,
    external_id
  };
};
